import areaData from './areaData'

export { areaData }

export default {
  areaData,

  InfoQServer: 'https://www.infoq.cn',
  tgoServer: 'https://tgo.infoq.cn',
  miscServer: 'https://misc.geekbang.org',
  accountServer: 'https://account.infoq.cn',
  adServer: 'https://a.geekbang.org',

  TGOMpAppId: 'wx4d8c063ab7630423'
}
